import { BaseEntityDto, UserRole } from '@fleet-beat/core';

export interface InvitePendingDto extends BaseEntityDto {
  id: string;
  tenantID: string;
  inviteByEmail: boolean;
  email: string;
  role: UserRole;
  url: string;
}
